export const API_BASE = 'https://living-resume-api.tedlango.workers.dev';

export const ENDPOINTS = {
  // Professional Identity
  about: { path: '/about', method: 'GET', category: 'Identity', label: 'About' },
  thesis: { path: '/thesis', method: 'GET', category: 'Identity', label: 'Core Thesis' },
  narrative: { path: '/narrative', method: 'GET', category: 'Identity', label: 'Narrative' },
  summary: { path: '/summary', method: 'GET', category: 'Identity', label: 'Summary' },

  // TELOS Framework
  mission: { path: '/mission', method: 'GET', category: 'Framework', label: 'Mission' },
  telos: { path: '/telos', method: 'GET', category: 'Framework', label: 'TELOS' },
  problems: { path: '/problems', method: 'GET', category: 'Framework', label: 'Problems' },
  goals: { path: '/goals', method: 'GET', category: 'Framework', label: 'Goals' },
  models: { path: '/models', method: 'GET', category: 'Framework', label: 'Models' },
  beliefs: { path: '/beliefs', method: 'GET', category: 'Framework', label: 'Beliefs' },

  // Evidence
  experience: { path: '/experience', method: 'GET', category: 'Evidence', label: 'Experience' },
  accomplishments: { path: '/accomplishments', method: 'GET', category: 'Evidence', label: 'Accomplishments' },
  'track-record': { path: '/track-record', method: 'GET', category: 'Evidence', label: 'Track Record' },
  skills: { path: '/skills', method: 'GET', category: 'Evidence', label: 'Skills' },
  education: { path: '/education', method: 'GET', category: 'Evidence', label: 'Education' },
  publications: { path: '/publications', method: 'GET', category: 'Evidence', label: 'Publications' },
  resources: { path: '/resources', method: 'GET', category: 'Evidence', label: 'Resources' },

  // Engagement
  seeking: { path: '/seeking', method: 'GET', category: 'Engagement', label: 'Seeking' },
  'cultural-fit': { path: '/cultural-fit', method: 'GET', category: 'Engagement', label: 'Cultural Fit' },
  availability: { path: '/availability', method: 'GET', category: 'Engagement', label: 'Availability' },
  offer: { path: '/offer', method: 'GET', category: 'Engagement', label: 'Value Proposition' },
  contact: { path: '/contact', method: 'GET', category: 'Engagement', label: 'Contact' },
  book: { path: '/book', method: 'GET', category: 'Engagement', label: 'Book' },

  // ATS / Recruiter
  'ats-keywords': { path: '/ats-keywords', method: 'GET', category: 'Recruiter', label: 'ATS Keywords' },
  'recruiter-summary': { path: '/recruiter-summary', method: 'GET', category: 'Recruiter', label: 'Recruiter Summary' },

  // Full profile
  full: { path: '/full', method: 'GET', category: 'Full', label: 'Complete Profile' },
} as const;

export type EndpointKey = keyof typeof ENDPOINTS;

export const ENDPOINT_CATEGORIES = ['Identity', 'Framework', 'Evidence', 'Engagement', 'Recruiter', 'Full'] as const;
